import React, { useState } from "react";
import { CalendarCheck, Coins, Loader2, Split } from "lucide-react";
import ActiveCardShell from "../ActiveCardShell";
import { useDemoBrand } from "@/lib/demoBrand";
import { sleep, RunButton, useAlive } from "../phase2/shared";

const TOTAL = 8412;
const TIERS = [
  ["ISO · VEROOGLE", 0.5, "from-brand-cyan to-brand-emerald"],
  ["Agent · M. Torres", 0.35, "from-blue-500 to-brand-cyan"],
  ["Sub-agent · K. Patel", 0.15, "from-violet-500 to-blue-500"],
];
const money = (n) => "$" + Math.round(n).toLocaleString();

export default function ResidualCard() {
  const { name } = useDemoBrand();
  const [p, setP] = useState(0);
  const [scheduled, setScheduled] = useState(false);
  const [running, setRunning] = useState(false);
  const alive = useAlive();

  const run = async () => {
    setRunning(true); setP(0); setScheduled(false);
    for (let i = 1; i <= 20; i += 1) { await sleep(60); if (!alive.current) return; setP(i / 20); }
    await sleep(700);
    if (!alive.current) return;
    setScheduled(true);
    setRunning(false);
  };

  return (
    <ActiveCardShell id="T4100cr" kicker="RESIDUALS" title="Multi-Tier Residual Engine" Icon={Split}
      actions={<RunButton tid="veroogle-t4100-run" running={running} onClick={run} Icon={running ? Loader2 : Coins} label="Run residuals" />}>
      <div className="flex items-baseline justify-between mb-3">
        <span className="font-mono text-[10px] tracking-[0.18em] uppercase text-slate-400">This month's residual</span>
        <span className="font-mono text-xl text-white" data-testid="veroogle-t4100-total">{money(TOTAL * p)}</span>
      </div>
      <div className="space-y-2.5">
        {TIERS.map(([rawLabel, share, grad], i) => { const label = rawLabel.replace("VEROOGLE", name); return (
          <div key={label} data-testid={`veroogle-t4100-tier-${i}`}>
            <div className="flex justify-between text-xs mb-1">
              <span className="text-slate-300">{label} <span className="text-slate-500">· {share * 100}%</span></span>
              <span className="font-mono text-white">{money(TOTAL * share * p)}</span>
            </div>
            <div className="h-2 rounded-full bg-white/5 overflow-hidden">
              <div className={`h-full bg-gradient-to-r ${grad} transition-[width] duration-100`} style={{ width: `${share * p * 100 / 0.5}%` }} />
            </div>
          </div>
        ); })}
      </div>
      {scheduled && (
        <div data-testid="veroogle-t4100-scheduled" className="mt-4 inline-flex items-center gap-2 px-3 py-1.5 rounded-lg border border-emerald-400/40 bg-emerald-500/10 text-emerald-200 text-xs animate-in fade-in">
          <CalendarCheck className="w-3.5 h-3.5" /> Payouts scheduled · ACH Friday
        </div>
      )}
    </ActiveCardShell>
  );
}
